export const withFallback = (value?: string | number, fallback = "--") => {
  if (typeof value === "string") return value.trim() || fallback;
  if (typeof value === "number") return value;
  return fallback;
};
